import { createContext } from 'react';
import type { TTicketsContextValue } from './Tickets.types.ts';

export const TicketsContext = createContext<TTicketsContextValue | undefined>(
  undefined,
);
